<div class="row hup-subscription">
  <div class="col-12  hup-subscription__intro">
    <h3 *appApplyIfNotEmpty="translationService.getTranslation('subscription_intro')"
        [innerHTML]="translationService.getTranslation('subscription_intro')"
        class="hup-subscription__title"></h3>
  </div>
  <div class="col-12 hup-subscription__description">
    <p [innerHTML]="translationService.getTranslation('subscription_description')"
        class="hup-subscription__subtitle"></p>
  </div>
</div>

<div class="row hup-subscription__list">
  <div class="col-12 hup-subscription__list-container">
    @if (isLoading) {
      <div style="text-align: center;" class="hup-subscription__loading">
        <app-loading-spinner/>
      </div>
    }
    @if (!isLoading && subs.length == 0) {
      <p [innerHTML]="translationService.getTranslation('intro_noSubs')"
           class="hup-subscription__no-subs"></p>
    }
    @if (!isLoading && subs.length > 0) {
      <div class="row">
      @for (sub of subs; track sub; let i = $index) {
        <div class="col-12 col-md-6 col-lg-4 mt-4">
        <mat-card appearance="outlined" class="hup-subscription__card">
          <div class="m-3 hup-subscription__card-row">
            <div tabindex="0" class="col-12 hup-subscription__card-info">
              <mat-card-title class="hup-subscription__product-title">{{ sub.productDescription }}</mat-card-title>
              @if (showSubscriptionStatus) {
                <div class="subscription-status float-end me-5 hup-subscription__status">
                  @switch (sub.state) {
                    @case (-1) {
                      <div [innerHTML]="translationService.getTranslation('orderstatus_admintool')"
                           class="hup-subscription__status--admintool"></div>
                    }
                    @case (0) {
                      <div [innerHTML]="translationService.getTranslation('orderstatus_active')"
                           class="hup-subscription__status--active"></div>
                    }
                    @case (1) {
                      <div [innerHTML]="translationService.getTranslation('orderstatus_future')"
                           class="hup-subscription__status--future"></div>
                    }
                    @case (3) {
                      <div [innerHTML]="translationService.getTranslation('orderstatus_terminated')"
                           class="hup-subscription__status--terminated"></div>
                    }
                  }
                </div>
              }
              @if (sub.subId) {
                <mat-card-subtitle [innerHTML]="translationService.getTranslation('order_id') + ': ' + sub.subId"
                                   class="hup-subscription__order-id">
                </mat-card-subtitle>
              }
              @if (sub.userBackendId) {
                <mat-card-subtitle
                  [innerHTML]="translationService.getTranslation('label_backendid') + ': ' + sub.userBackendId"
                  class="hup-subscription__backend-id">
                </mat-card-subtitle>
              }
              @if (sub.variantDescription) {
                <mat-card-subtitle
                  [innerHTML]="translationService.getTranslation('order_edition') + ': ' + sub.variantDescription"
                  class="hup-subscription__edition">
                </mat-card-subtitle>
              }
              @if (sub.validDate) {
                <mat-card-subtitle [innerHTML]="translationService.getTranslation('period') + ': ' +
                               (sub.validDate.validFrom | date: translationService.getTranslation('dateFormat')) + ' - ' +
                               ((sub.validDate.validUntil) ? (sub.validDate.validUntil | date: translationService.getTranslation('dateFormat')) : translationService.getTranslation('subscription_endless'))"
                                   class="hup-subscription__period">
                </mat-card-subtitle>
              }
              @if (sub.curDelivery) {
                <mat-card-subtitle class="hup-subscription__delivery">
                  {{ sub.curDelivery.person.addressCodeDescription }}
                  {{ sub.curDelivery.person.firstname }}
                  {{ sub.curDelivery.person.lastname }},
                  {{ sub.curDelivery.address.city }},
                  {{ sub.curDelivery.address.street }} {{ sub.curDelivery.address.houseno | houseNoPipe }}
                </mat-card-subtitle>
              }
            </div>
            <div class="col-12 hup-subscription__card-actions">
              <mat-card-actions class="card-actions hup-subscription__actions">
                <!--
                <button mat-raised-button color="primary" *ngIf="sub.state === -1"
                (click)="cancelOrder(sub)">{{translationService.getTranslation('button_storno')}}</button>
                -->
                <button mat-raised-button color="primary"
                        [innerHTML]="translationService.getTranslation('button_details')"
                        (click)="aboDetails(sub)" class="mt-2 hup-subscription__details-btn"></button>
              </mat-card-actions>
            </div>

          </div>
        </mat-card>
        </div>
      }
      </div>
    }
  </div>
</div>
